import type { ButtonHTMLAttributes, ReactNode } from 'react'

interface Props extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  label: string
  children: ReactNode
}

export function IconBtn({ label, children, ...rest }: Props) {
  return (
    <button className="icon-btn" aria-label={label} {...rest}>
      {children}
    </button>
  )
}
